import { render, staticRenderFns } from "./BookingStatusDialog.vue?vue&type=template&id=30636bcc"
import script from "./BookingStatusDialog.vue?vue&type=script&lang=js"
export * from "./BookingStatusDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports